import { useReducedMotion as useFramerReducedMotion } from "framer-motion";

/**
 * Returns `true` when the user has enabled the browser/OS "Reduce Motion"
 * accessibility setting (`prefers-reduced-motion: reduce`).
 *
 * Backed by framer-motion's `useReducedMotion`, which reads the media query
 * reactively — the value updates if the user changes the setting while the
 * page is open.
 *
 * All framer-motion animations are also suppressed globally via
 * `<MotionConfig reducedMotion="user">` in App.tsx; use this hook when you
 * need to explicitly gate non-framer-motion behaviour (e.g. CSS class toggling,
 * scroll behaviour, or canvas animations) on the same preference.
 */
export function useReducedMotion(): boolean {
  return useFramerReducedMotion() ?? false;
}
